module.exports = __webpack_public_path__ + "img/MES3VideoThumbnail.6fd32db0.png";